(function () {
  'use strict';

  function lockViewer(viewer) {
    if (!viewer) return;
    viewer.setAttribute('disable-zoom', '');
    viewer.setAttribute('touch-action', 'none');
    viewer.addEventListener(
      'wheel',
      function (e) {
        e.preventDefault();
        e.stopPropagation();
      },
      { passive: false }
    );
    var markReady = function () {
      var wrap = viewer.closest('.drip-hero__glb');
      if (wrap) wrap.classList.add('is-ready');
    };
    viewer.addEventListener('load', markReady);
    if (viewer.loaded) markReady();
    setTimeout(markReady, 1200);

    /* Pause 3D when off-screen — big desktop GPU win */
    if (typeof IntersectionObserver !== 'undefined') {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            try {
              if (entry.isIntersecting) {
                if (viewer.hasAttribute('data-dh-was-rotate')) viewer.setAttribute('auto-rotate', '');
                if (typeof viewer.resume === 'function') viewer.resume();
              } else {
                if (viewer.hasAttribute('auto-rotate')) {
                  viewer.setAttribute('data-dh-was-rotate', '');
                  viewer.removeAttribute('auto-rotate');
                }
                if (typeof viewer.pause === 'function') viewer.pause();
              }
            } catch (_) {}
          });
        },
        { rootMargin: '10% 0px', threshold: 0.05 }
      );
      io.observe(viewer);
    }
  }

  function init(root) {
    if (!root || root.__dhInit) return;
    root.__dhInit = true;
    root.querySelectorAll('model-viewer').forEach(lockViewer);

    var video = root.querySelector('[data-dh-video]');
    if (video) {
      var tryPlay = function () {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      };
      tryPlay();
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) tryPlay();
      });
    }
  }

  function scan() {
    document.querySelectorAll('[data-drip-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('[data-drip-hero]');
    if (root) init(root);
  });
})();
